import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { provinceAndCityAdminContext } from "../../../context/Admin/ProvinceAndCityAdminContext/ProvinceAndCityAdminContext";

const CityAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    provinces,
    cities,
    id,
    name,
    setName,
    province,
    setProvince,
    isEnabled,
    setIsEnabled,
    isShowModal,
    handleShowModal,
    handleCloseModal,
    handleGetCities,
    handleCreateCity,
    handleEditCity,
    handleDeleteCity,
    handleGetProvinces,
  } = useContext(provinceAndCityAdminContext);

  useEffect(() => {
    handleGetCities();
    handleGetProvinces();
  }, []);

  return (
    <>
      <SiteTitle title="شهر" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "شهر", type: "a" },
        ]}
        title="آیتم های شهر"
      />

      <CardLayout>
        {permission.city_create_update && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        {isEmpty(cities) ? (
          <EmptyData />
        ) : (
          <Table responsive hover borderless striped>
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>شناسه</th>
                <th>نام</th>
                <th>استان</th>
                <th>وضعیت</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {cities.map((_item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{_item.id}</td>
                  <td>{_item.name}</td>
                  <td>
                    {provinces?.find((_p) => _p?.id === _item.province)?.name ??
                      _item.province}
                  </td>
                  <td>
                    {_item.isEnabled ? (
                      <span className="badge badge-success">
                        <i className="bx bx-check" /> فعال
                      </span>
                    ) : (
                      <span className="badge badge-danger">
                        <i className="bx bx-x" /> غیرفعال
                      </span>
                    )}
                  </td>
                  <td className="mw-25">
                    {permission.city_create_update && (
                      <button
                        onClick={() => handleShowModal(_item)}
                        className="btn btn-primary mr-2"
                      >
                        ویرایش
                      </button>
                    )}
                    {permission.city_delete && (
                      <i
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteCity(_item.id),
                            `آیا از حذف ${_item.name} اطمینان دارید؟`
                          )
                        }
                        className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} شهر`}
        show={isShowModal}
        onHide={handleCloseModal}
        size="lg"
      >
        <form
          onSubmit={id ? handleEditCity : handleCreateCity}
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="name">نام</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="province">استان</label>
              <select
                className="form-control"
                name="type"
                id="province"
                defaultValue={province}
                onChange={(e) => setProvince(e.target.value)}
              >
                <option selected value="">
                  لطفا استان را انتخاب نمایید
                </option>
                {provinces?.map((_value) => (
                  <option key={_value.id} value={_value.name}>
                    {_value.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="isEnabled">وضعیت</label>
              <div className="d-flex  align-items-center">
                <label htmlFor="isEnabled" className="mr-2">
                  فعال
                </label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isEnabled}
                    id="isEnabled"
                    onClick={(e) => setIsEnabled(e.target.checked)}
                  />
                  <span className="slider round"></span>
                </label>
                <label htmlFor="isEnabled" className="ml-2">
                  غیرفعال
                </label>
              </div>
            </div>
          </div>
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}
    </>
  );
};

export default CityAdmin;
